import { createFileRoute } from "@tanstack/react-router"
import Reporting from "~/pages/reporting"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/reporting")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Reporting")
  return <Reporting />
}
